// DO NOT EDIT — generated by `yarn flags generate`. Source: PostHog (tag: tribe-neo).

import type { FlagMetadata } from './registry-types.js'

/** Keys are lowercase-kebab. */
export const FlagKeys = {
  DesignStudioNexusEnabled: 'design-studio-nexus-enabled',
  HtmlContentBoundary: 'html-content-boundary',
  LocaleGroupsEnabled: 'locale-groups-enabled',
  McpSettingsEnabled: 'mcp-settings-enabled',
  SpaceWarningsEnabled: 'space-warnings-enabled',
  SsrPostsFeedPrefetchEnabled: 'ssr-posts-feed-prefetch-enabled',
  SsrPrefetchCollectionMenu: 'ssr-prefetch-collection-menu',
  SsrPrefetchFeed: 'ssr-prefetch-feed',
  SsrPrefetchNavigationSlates: 'ssr-prefetch-navigation-slates',
  SsrPrefetchPosts: 'ssr-prefetch-posts',
  ToggyModerateBannerEnabled: 'toggy-moderate-banner-enabled',
} as const

export type FlagKey = (typeof FlagKeys)[keyof typeof FlagKeys]

/**
 * Keys of flags tagged `client` — consumed by the SSR snapshot and delivered
 * to the browser. Derived at codegen time from PostHog tags.
 */
export const CLIENT_FLAG_KEYS = [
  FlagKeys.DesignStudioNexusEnabled,
  FlagKeys.HtmlContentBoundary,
  FlagKeys.LocaleGroupsEnabled,
  FlagKeys.McpSettingsEnabled,
  FlagKeys.SpaceWarningsEnabled,
  FlagKeys.ToggyModerateBannerEnabled,
] as const

export type ClientFlagKey = (typeof CLIENT_FLAG_KEYS)[number]

export const FLAG_METADATA: Record<FlagKey, FlagMetadata> = {
  [FlagKeys.DesignStudioNexusEnabled]: {
    key: FlagKeys.DesignStudioNexusEnabled,
    classification: 'static',
    sendFeatureFlagEvents: false,
    client: true,
    defaultValue: true,
  },
  [FlagKeys.HtmlContentBoundary]: {
    key: FlagKeys.HtmlContentBoundary,
    classification: 'static',
    sendFeatureFlagEvents: false,
    client: true,
    defaultValue: true,
  },
  [FlagKeys.LocaleGroupsEnabled]: {
    key: FlagKeys.LocaleGroupsEnabled,
    classification: 'static',
    sendFeatureFlagEvents: false,
    client: true,
    defaultValue: true,
  },
  [FlagKeys.McpSettingsEnabled]: {
    key: FlagKeys.McpSettingsEnabled,
    classification: 'static',
    sendFeatureFlagEvents: false,
    client: true,
    defaultValue: false,
  },
  [FlagKeys.SpaceWarningsEnabled]: {
    key: FlagKeys.SpaceWarningsEnabled,
    classification: 'static',
    sendFeatureFlagEvents: false,
    client: true,
    defaultValue: false,
  },
  [FlagKeys.SsrPostsFeedPrefetchEnabled]: {
    key: FlagKeys.SsrPostsFeedPrefetchEnabled,
    classification: 'static',
    sendFeatureFlagEvents: false,
    client: false,
    defaultValue: false,
  },
  [FlagKeys.SsrPrefetchCollectionMenu]: {
    key: FlagKeys.SsrPrefetchCollectionMenu,
    classification: 'static',
    sendFeatureFlagEvents: false,
    client: false,
    defaultValue: false,
  },
  [FlagKeys.SsrPrefetchFeed]: {
    key: FlagKeys.SsrPrefetchFeed,
    classification: 'static',
    sendFeatureFlagEvents: false,
    client: false,
    defaultValue: false,
  },
  [FlagKeys.SsrPrefetchNavigationSlates]: {
    key: FlagKeys.SsrPrefetchNavigationSlates,
    classification: 'static',
    sendFeatureFlagEvents: false,
    client: false,
    defaultValue: false,
  },
  [FlagKeys.SsrPrefetchPosts]: {
    key: FlagKeys.SsrPrefetchPosts,
    classification: 'static',
    sendFeatureFlagEvents: false,
    client: false,
    defaultValue: false,
  },
  [FlagKeys.ToggyModerateBannerEnabled]: {
    key: FlagKeys.ToggyModerateBannerEnabled,
    classification: 'static',
    sendFeatureFlagEvents: false,
    client: true,
    defaultValue: false,
  },
}
